import React, { useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { goodsLibraryStore } from '../../store/goods-library'
import { SecondaryGroup } from '@/model/types/goods'
import { getBEMCls } from '@/utils/classname'
import { Popover } from 'antd'
import { showLayer } from '@/utils/layer'
import EditGroup, { DeleteGroup } from './edit-group'
import { get } from '@/utils'

interface SecondItemGroupProps {
    second: SecondaryGroup
    groupId: number | undefined
}

const SecondItemGroup: React.FC<SecondItemGroupProps> = observer(props => {
    const getCls = (e?: string, m?: string) => getBEMCls('goods-group', e, m)
    const [popoverVisable, setPopoverVisable] = useState<boolean>(false)

    const hidePopover = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation()
        setPopoverVisable(false)
    }

    const selectNum = useMemo(() => {
        return get(goodsLibraryStore.selectGroupNum, `${props.groupId}.${props.second.id}`, 0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [goodsLibraryStore.selectGroupNum])

    return (
        <div
            className={`${
                goodsLibraryStore.secondGroupId === props.second.id ? getCls('menu', 'active') : getCls('menu')
            }`}
            onClick={() => {
                goodsLibraryStore.setActiveGroupId(props.groupId)
                goodsLibraryStore.setActiveSecondGroupId(props.second.id)
            }}
        >
            {!!selectNum && <div className={getCls('badge')}>{selectNum}</div>}
            <div>
                <Popover
                    visible={popoverVisable}
                    onVisibleChange={() => setPopoverVisable(!popoverVisable)}
                    trigger="click"
                    placement="bottomRight"
                    content={
                        <>
                            <div
                                className={`${getCls('list-item')}`}
                                onClick={e => {
                                    hidePopover(e)
                                    showLayer(
                                        <EditGroup
                                            name={props.second.name}
                                            secondId={props.second.id}
                                            groupId={props.groupId}
                                        />,
                                    )
                                }}
                            >
                                编辑
                            </div>
                            <div
                                className={`${getCls('list-item')}`}
                                style={{
                                    color: '#FF4343',
                                }}
                                onClick={e => {
                                    hidePopover(e)
                                    showLayer(
                                        <DeleteGroup
                                            name={props.second.name}
                                            num={props.second.goods_num}
                                            groupId={props.groupId}
                                            secondId={props.second.id}
                                        />,
                                    )
                                }}
                            >
                                删除
                            </div>
                        </>
                    }
                >
                    <i
                        className={`iconfont iconmore2 ${getCls('more')}`}
                        onClick={e => {
                            e.stopPropagation()
                            setPopoverVisable(!popoverVisable)
                        }}
                    />
                </Popover>
                <span>{props.second.goods_num}</span>
            </div>
            {props.second?.name}
        </div>
    )
})

export default SecondItemGroup
